import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import {
  usePostAlerts,
  usePostReadAll,
} from '~/react-query-hooks/events/use-event-alerts/useEventAlerts';
import { appPaths } from '~/routes/app-paths';

import * as S from './Header.styles';
import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

export interface HeaderProps {
  activeButtonIndex: number;
  onButtonClick: (index: number) => void;
  onClose: () => void;
}

export const Header = ({
  activeButtonIndex,
  onButtonClick,
  onClose,
}: HeaderProps) => {
  const { t } = useTranslation('alerts');
  const navigate = useNavigate();
  const { mutate: readAllAlerts } = usePostReadAll();
  const { data } = usePostAlerts({ count_only: true });
  const unreadCount = data?.pages[0]?.unread_count ?? 0;

  const handleNavigateToAlerts = () => {
    onClose();
    navigate(appPaths.alerts);
  };

  const buttonLabels = [
    t('alerts:all'),
    t('alerts:unread', { count: unreadCount }),
  ];

  return (
    <S.HeaderWrapper>
      <S.TitleAndButtonRow>
        <S.Title>{t('dropdown.title')}</S.Title>
        <S.ButtonContainer>
          <TooltipContainer
            label={
              <S.TooltipLabel>
                {t('alerts:dropdown.markAllAsRead')}
              </S.TooltipLabel>
            }
          >
            <Button
              variant="empty"
              size="xsmall"
              iconName="CheckDouble"
              onClick={() => readAllAlerts()}
            />
          </TooltipContainer>
          <TooltipContainer
            label={
              <S.TooltipLabel>
                {t('alerts:dropdown.viewAllAlerts')}
              </S.TooltipLabel>
            }
          >
            <Button
              variant="empty"
              size="xsmall"
              iconName="Expand"
              onClick={handleNavigateToAlerts}
            />
          </TooltipContainer>
        </S.ButtonContainer>
      </S.TitleAndButtonRow>
      <S.StyledButtonGroup
        labels={buttonLabels}
        activeIndex={activeButtonIndex}
        onClick={onButtonClick}
      />
    </S.HeaderWrapper>
  );
};
